export default "__VITE_ASSET__8cf49f61__"